var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height ? _vm.height+'px' : undefined})},[(_vm.editor)?_c('div',{staticClass:"d-flex justify-center empty-editor"},[_vm._v(" "+_vm._s(_vm.fieldRec.name)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }